module.exports = __webpack_public_path__ + "img/zeno-4.67b4f347.jpg";